/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { setDoc, doc, updateDoc } from "firebase/firestore";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { db } from "../../../firebase";
import usePagination from "../../helper/paginate/Pagination";
import "./DataTableDemo.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import freeCountries from "../../../utils/freeCountries.json";
import axios from "axios";
import moment from "moment";
import { ChevronDown, ChevronUp, Tag, MoreVertical, Eye } from "lucide-react";
import { useTranslation } from "react-i18next";
import "moment/locale/ar";
import "moment/locale/fr";
import Swal from "sweetalert2";

const DataTableTemplatingDemoDashboard = ({ filter, orders, pageSize }) => {
  const useIsDark = () => {
    const getIsDark = () => document.documentElement.classList.contains("dark");
    const [isDark, setIsDark] = useState(getIsDark);

    useEffect(() => {
      const observer = new MutationObserver(() => {
        setIsDark(getIsDark());
      });

      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["class"],
      });

      return () => observer.disconnect();
    }, []);

    return isDark;
  };
  const isDark = useIsDark();
  const currentDate = new Date();
  const account = useSelector((state) => state.AccountReducer);
  const isFreeCountry = freeCountries.includes(account?.country);
  const store = useSelector((state) => state.StoreReducer);
  const productdata = useSelector((state) => state.ProductsReducer);
  let [page, setPage] = useState(1);
  const PER_PAGE = pageSize;
  const count = Math.ceil(orders.length / PER_PAGE);
  const _DATA = usePagination(orders, PER_PAGE);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const [activeStatusDropdown, setActiveStatusDropdown] = useState(null);
  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  moment.defineLocale("fr-num", {
    parentLocale: "fr",
    months: moment.locales("fr").months,
    monthsShort: moment.locales("fr").monthsShort,
    weekdays: moment.locales("fr").weekdays,
    weekdaysShort: moment.locales("fr").weekdaysShort,
    weekdaysMin: moment.locales("fr").weekdaysMin,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm",
    },
    relativeTime: {
      future: "dans %s",
      past: "il y a %s",
      s: "quelques secondes",
      ss: "%d secondes",
      m: "une minute",
      mm: "%d minutes",
      h: "une heure",
      hh: "%d heures",
      d: "un jour",
      dd: "%d jours",
      M: "un mois",
      MM: "%d mois",
      y: "une année",
      yy: "%d années",
    },
    preparse: function (string) {
      return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
        return "٠١٢٣٤٥٦٧٨٩".indexOf(match);
      });
    },
  });
  const formatDate = (dateObj) => {
    if (!dateObj || !dateObj.seconds) {
      return t("dontexist");
    }

    const timestamp = dateObj.seconds * 1000;
    const now = Date.now();
    const date = moment(timestamp).locale("fr-num");
    const diff = now - timestamp;

    if (diff < 60000) {
      return `${t(
        "dashboard.DataTableTemplatingDemoDashboard.depuis"
      )} ${Math.floor(diff / 1000)} ${t(
        "dashboard.DataTableTemplatingDemoDashboard.seconde"
      )} `;
    } else if (diff < 3600000) {
      return `${t(
        "dashboard.DataTableTemplatingDemoDashboard.depuis"
      )} ${Math.floor(diff / 60000)} ${t(
        "dashboard.DataTableTemplatingDemoDashboard.minute"
      )}`;
    } else if (diff < 86400000) {
      return `${t(
        "dashboard.DataTableTemplatingDemoDashboard.depuis"
      )} ${Math.floor(diff / 3600000)} ${t(
        "dashboard.DataTableTemplatingDemoDashboard.heure"
      )}`;
    } else if (diff < 604800000) {
      return `${t(
        "dashboard.DataTableTemplatingDemoDashboard.depuis"
      )} ${Math.floor(diff / 86400000)} ${t(
        "dashboard.DataTableTemplatingDemoDashboard.jour"
      )}`;
    } else if (diff < 604800000 + 86400000) {
      return t("dashboard.DataTableTemplatingDemoDashboard.lastSemaine");
    } else {
      return date.format("YYYY-MM-DD, H:mm:ss");
    }
  };

  const getStatusOrderText = (order) => {
    if (order.deleveryStatus === "5" || order.status === "completed") {
      return t("orders.completed");
    } else if (order.deleveryStatus === "3") {
      return t("stats.confirmed");
    } else if (order.deleveryStatus === "9") {
      return t("ui.confirmedByCustomer");
    } else if (
      order.deleveryStatus === "1" ||
      order.status === "pending" ||
      !order.deleveryStatus
    ) {
      return t("stats.pending");
    } else if (order.deleveryStatus === "6") {
      return t("orderDetails.statusOptions.6");
    } else if (order.deleveryStatus === "11-5") {
      return t("ui.cancelledByCustomer");
    } else if (order.deleveryStatus === "11-1") {
      return t("ui.awaitingCustomer");
    } else if (order.deleveryStatus === "11-2") {
      return t("ui.noAnswer");
    } else if (order.deleveryStatus === "11-3") {
      return t("stats.postponed");
    } else if (order.deleveryStatus === "11-4") {
      return t("ui.lineClosed");
    } else if (order.status === "processing") {
      return t("ui.processing");
    }
    return order.statusText || order.status || "قيد الانتظار";
  };

  const maxChars = 25;
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    }
    return text;
  };
  const changeStatus = async (data, status) => {
    const currentTime = new Date();
    const updatedStatusTimeline = [
      ...(data.statusTimeline || []),
      { status, timestamp: currentTime, ownby: account.name },
    ];
    const telegramBotToken = "6672968395:AAHFokejZq4r6GRRDHlm2FDqXk0-pXoQmOs";
    const chatId = store.Idtelegram;
    const product = productdata.find(
      (product) => product.id === data.productId
    );
    const truncatedProductName = truncateText(
      data.nameproduct ? data.nameproduct : product.name,
      maxChars
    );
    const statusMessages = {};

    if (store.done === true) {
      statusMessages[
        "5"
      ] = `✅ تم إتمام الطلب بنجاح! ✅\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنود إبلاغكم بأنه تم إتمام الطلب بنجاح. يمكنكم متابعة تفاصيل وضعية الطلب وموعد التسليم عبر البوابة الخاصة بكم. شكرًا لتفهمكم وثقتكم في خدماتنا.`;
    }
    const statusMessagess = {};

    if (store.termine === true) {
      statusMessagess[
        "11-2"
      ] = `📢 طلب لم يرد على الاتصال! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "لم يرد على الاتصال". نقترح محاولة الاتصال مع العميل لاحقًا لتأكيد التفاصيل. شكرًا لك على تفانيك في تقديم خدمة عالية الجودة.`;
      statusMessagess[
        "11-3"
      ] = `📢 طلب مؤجل! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تأجيل تسليم الطلب إلى وقت لاحق. ننصح بجدولة الاتصال بالعميل لترتيب تفاصيل موعد التسليم المناسب. نقدر جهودك في تقديم الخدمة المميزة.`;
      statusMessagess[
        "11-5"
      ] = `📢 إلغاء طلب! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم إلغاء الطلب من قبل العميل. يُرجى ترتيب إجراءات الإلغاء ومتابعة الإجراءات المناسبة. نشكرك على تفهمك واهتمامك برضاء العملاء.`;
      statusMessagess[
        "11-1"
      ] = `📢 انتضار اتصال العميل ! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "انتظار اتصال العميل". يُرجى محاولة التواصل مع العميل بأسرع وقت ممكن لتأكيد التفاصيل وترتيب التسليم المناسب. شكرًا لك على اهتمامك بتقديم الخدمة الفائقة.`;
      statusMessagess[
        "11-4"
      ] = `📢 طلب خط مغلق! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "الخط مغلق". نود إبلاغك بأن العميل قد يكون غير متاح حاليًا. ننصح بمحاولة الاتصال في وقت لاحق أو ترتيب وقت مناسب للتواصل. نشكرك على جهودك في تقديم أفضل خدمة للعملاء.`;
    }

    const statusMessagees = {};

    if (store.confrim === true) {
      statusMessagees[
        "3"
      ] = `📢 طلب مؤكد! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "مؤكدة". ننصح برفع الطلب في شركة التوصيل لبدء إجراءات التوصيل. شكرًا لك على جهودك في تقديم أفضل تجربة للعميل وتسهيل عملية التسليم.`;
    }
    if (store.confrim === true) {
      statusMessagees[
        "9"
      ] = `📢 طلب مؤكد من قبل العميل! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "مؤكدة". ننصح برفع الطلب في شركة التوصيل لبدء إجراءات التوصيل. شكرًا لك على جهودك في تقديم أفضل تجربة للعميل وتسهيل عملية التسليم.`;
    }

    const statusMessageesNew = {};

    if (store.new === true) {
      statusMessageesNew[
        "1"
      ] = `📢 تحديث حالة الطلب! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nلدينا تحديث جديد على حالة الطلب. يُرجى تأكيد ومتابعة الحالة الجديدة في أقرب وقت ممكن. شكرًا لك على اهتمامك بتقديم خدمة مميزة وتلبية احتياجات العملاء بكل دقة وسرعة.`;
    }

    const statusMessagessDD = {};

    if (store.delevery === true) {
      statusMessagessDD[
        "4"
      ] = `🚚 طلب تم رفعه لشركة التوصيل! 🚚\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنود إعلامك بأنه تم رفع الطلب لشركة التوصيل بنجاح. يتم الآن التنسيق لبدء عملية التسليم. نشكرك على جهودك واهتمامك بتقديم تجربة مميزة للعميل.`;
    }
    const statusMessagessCC = {};

    if (store.cancel === true) {
      statusMessagessDD[
        "6"
      ] = `❌ تم الغاء الطلب! ❌\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنأسف لإبلاغكم بأن العميل قام بإلغاء الطلب. تم تحديث حالة الطلب بنجاح. شكرًا على جهودك في تقديم الخدمة ونأمل في تقديم تجربة أفضل في المستقبل.`;
    }
    const message =
      statusMessages[status] ||
      statusMessagees[status] ||
      statusMessagessCC[status] ||
      statusMessageesNew[status] ||
      statusMessagessDD[status] ||
      statusMessagess[status];
    const messageC = `📵 حالة الطلب غير مكتملة! 📵\n\n👤 العميل: ${data.name}\n📞 الهاتف: ********\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنرجو إعلامك بأن رقم هاتف الطلب غير ظاهر بسبب عدم توفر رصيد كافي أو عدم تفعيل باقتك في فوورويب . يُرجى التحقق من حالة رصيدك وتفعيل الباقة لتتمكن من متابعة تفاصيل طلبك بشكل كامل. شكرًا على تفهمك ونتطلع لخدمتك بشكل أفضل.`;

    await setDoc(doc(db, "orders", data.id), {
      ...data,
      deleveryStatus: status,
      statusTimeline: updatedStatusTimeline,
      ownby: account.name,
    });

    {
      data.isValid
        ? axios
            .post(
              `https://api.telegram.org/bot${telegramBotToken}/sendMessage`,
              {
                chat_id: chatId,
                text: messageC,
              }
            )
            .then((response) => {
              console.log("تم إرسال الإشعار بنجاح");
            })
            .catch((error) => {
              console.error("حدث خطأ أثناء إرسال الإشعار", error);
            })
        : axios
            .post(
              `https://api.telegram.org/bot${telegramBotToken}/sendMessage`,
              {
                chat_id: chatId,
                text: message,
              }
            )
            .then((response) => {
              console.log("تم إرسال الإشعار بنجاح");
            })
            .catch((error) => {
              console.error("حدث خطأ أثناء إرسال الإشعار", error);
            });
    }
  };

  const handleCopyPhone = async (phone, event) => {
    const showSuccessNotification = (targetElement) => {
      const rect = targetElement.getBoundingClientRect();

      const successMsg = document.createElement("div");
      successMsg.innerHTML = t(
        "dashboard.DataTableTemplatingDemoDashboard.copy"
      );
      successMsg.style.cssText = `
      position: fixed;
      top: ${rect.bottom + 10}px;
      left: ${rect.left + rect.width / 2}px;
      transform: translateX(-50%);
      background: linear-gradient(135deg, #4CAF50, #45a049);
      color: white;
      padding: 12px 20px;
      border-radius: 25px;
      font-size: 14px;
      font-weight: bold;
      z-index: 10000;
      direction: rtl;
      font-family: Arial, sans-serif;
      box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);
      border: 2px solid rgba(255, 255, 255, 0.3);
      animation: copySuccess 0.6s ease-out;
      white-space: nowrap;
    `;

      if (!document.getElementById("copy-success-animation")) {
        const style = document.createElement("style");
        style.id = "copy-success-animation";
        style.textContent = `
        @keyframes copySuccess {
          0% {
            opacity: 0;
            transform: translateX(-50%) translateY(-10px) scale(0.8);
          }
          50% {
            opacity: 1;
            transform: translateX(-50%) translateY(0) scale(1.05);
          }
          100% {
            opacity: 1;
            transform: translateX(-50%) translateY(0) scale(1);
          }
        }
        @keyframes copyFadeOut {
          0% {
            opacity: 1;
            transform: translateX(-50%) translateY(0) scale(1);
          }
          100% {
            opacity: 0;
            transform: translateX(-50%) translateY(-10px) scale(0.9);
          }
        }
      `;
        document.head.appendChild(style);
      }

      document.body.appendChild(successMsg);

      setTimeout(() => {
        successMsg.style.animation = "copyFadeOut 0.3s ease-in forwards";
        setTimeout(() => {
          if (document.body.contains(successMsg)) {
            document.body.removeChild(successMsg);
          }
        }, 300);
      }, 1700);
    };

    try {
      await navigator.clipboard.writeText(phone);
      showSuccessNotification(event.target);
    } catch (err) {
      console.error("Failed to copy: ", err);
      const textArea = document.createElement("textarea");
      textArea.value = phone;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);

      showSuccessNotification(event.target);
    }
  };
  const navigate = useNavigate();
  const navigateToOrder = (orderId) => {
    if (orderId) {
      if ((account.productMode ?? "classic") == "classic") {
        navigate(`/orderProfile/${orderId}`);
      } else {
        navigate(`/digital-order-profile/${orderId}`);
      }
    } else {
      console.error("Order ID not found!");
    }
  };

  const [expandedRows, setExpandedRows] = useState({});
  const toggleRow = (orderId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [orderId]: !prev[orderId],
    }));
  };
  const filteredOrders = filter
    ? orders.filter(
        (order) =>
          order.index.toString().toLowerCase().includes(filter.toLowerCase()) ||
          order.name.toLowerCase().includes(filter.toLowerCase()) ||
          order.phone.toLowerCase().includes(filter.toLowerCase())
      )
    : orders;

  let isFunctionRunning = false;

  const handlePay = async (rowData) => {
    // إذا كانت الدالة تعمل بالفعل، فلا تقوم بتنفيذها مرة أخرى
    if (isFunctionRunning) {
      return;
    }

    isFunctionRunning = true; // تعيين المتغير إلى true للإشارة إلى أن الدالة تعمل حاليًا

    const isOnline = navigator.onLine;

    if (!isOnline) {
      // رسالة عندما لا يكون هناك اتصال بالإنترنت
      Swal.fire({
        icon: "error",
        title: t("ship.no_internet"),
        text: t("orderDetails.alerts.internet.text"),
        confirmButtonText: t("orders.datatable_templating_demo.okay"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      isFunctionRunning = false; // استعادة المتغير إلى false بمجرد انتهاء الدالة
      return;
    }

    if (
      account.subscription.tokens > 0 ||
      account.subscription.endDate.seconds > currentDate
    ) {
      setDoc(doc(db, "account", account.id), {
        ...account,
        subscription: !(account.subscription.endDate.seconds > currentDate)
          ? { ...account.subscription, tokens: account.subscription.tokens - 1 }
          : { ...account.subscription },
      }).then(
        updateDoc(doc(db, "orders", rowData?.id), {
          isValid: false,
        }).then(() => {
          isFunctionRunning = false; // استعادة المتغير إلى false بمجرد انتهاء الدالة
        })
      );
    } else {
      Swal.fire({
        icon: "error",
        title: t("ship.insufficient_balance"),
        text: t("ship.insufficient_balance_message"),
        confirmButtonText: t("ship.recharge_balance"),
        confirmButtonColor: "rgb(141, 93, 167)",
        showCancelButton: true,
        cancelButtonText: t("annule"),
        cancelButtonColor: "#e87778",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/plan";
        }
        isFunctionRunning = false; // استعادة المتغير إلى false بمجرد انتهاء الدالة
      });
    }
  };

  return (
    <div className="bg-white dark:!bg-[#181919] col-span-1 md:col-span-2 rounded-xl shadow-md w-full border border-[#fbf4ff] dark:!border-[#3c3a3d]">
      <div className="p-6 flex flex-col h-full" dir={isRTL ? "rtl" : "ltr"}>
        <h5
          className={`font-bold text-lg text-gray-800 dark:text-white m-0 flex items-center ${
            isRTL ? "flex-row-reverse" : ""
          }`}
        >
          {t("dashboard.DataTableTemplatingDemoDashboard.title")}
        </h5>

        <div className="w-full overflow-visible bg-white rounded-xl mt-4 shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full" dir={isRTL ? "rtl" : "ltr"}>
              <thead className="dark:!text-white">
                <tr className="bg-purple-50 dark:!bg-[#141414] rounded-t-xl">
                  {((account.productMode ?? "classic") == "classic"
                    ? [
                        "dashboard.DataTableTemplatingDemoDashboard.product",
                        "dashboard.DataTableTemplatingDemoDashboard.custumer",
                        "phone",
                        "dashboard.DataTableTemplatingDemoDashboard.orderDate",
                        "dashboard.DataTableTemplatingDemoDashboard.wilaya",
                        "dashboard.DataTableTemplatingDemoDashboard.status",
                        "dashboard.DataTableTemplatingDemoDashboard.total",
                        "",
                        "",
                      ]
                    : [
                        "dashboard.DataTableTemplatingDemoDashboard.product",
                        "dashboard.DataTableTemplatingDemoDashboard.custumer",
                        "phone",
                        "dashboard.DataTableTemplatingDemoDashboard.orderDate",
                        "dashboard.DataTableTemplatingDemoDashboard.total",
                        "",
                        "",
                      ]
                  ).map((header, index) => (
                    <th
                      key={index}
                      className={`p-4 font-medium text-[#9e68ba] dark:text-white ${
                        isRTL ? "text-right" : "text-left"
                      }`}
                    >
                      {t(header)}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {filteredOrders.length > 0 ? (
                  filteredOrders.map((order, index) => {
                    const STATUS_LABELS = {
                      0: "جديد",
                      1: "انتظار دفع العميل",
                      2: "انتظار تأكيد الدفع",
                      3: "مدفوع و انتظار المنتج",
                      4: "الدفع مرفوض",
                      5: "مكتملة",
                    };

                    return (
                      <React.Fragment key={order.id || index}>
                        <tr
                          className={`border-b dark:!border-[#3c3a3d] hover:bg-[#fcf6ff] dark:hover:!bg-[#0f172a] transition-colors ${
                            index % 2 === 0
                              ? "bg-white dark:!bg-[#181919]"
                              : "bg-gray-50 dark:bg-[#181919]"
                          }`}
                        >
                          <td className="p-4">
                            <div className="relative w-16 h-16">
                              {order.products?.some((p) => p.image) ? (
                                <>
                                  {order.products
                                    .filter((p) => p.image)
                                    .slice(0, 3)
                                    .map((product, imgIndex) => (
                                      <div
                                        key={imgIndex}
                                        className={`absolute rounded-lg overflow-hidden shadow-sm border-2 border-white w-14 h-14 bg-[#faf1ff] ${
                                          imgIndex === 0
                                            ? "z-30"
                                            : imgIndex === 1
                                            ? `${
                                                isRTL ? "left-2" : "right-2"
                                              } top-1 z-20`
                                            : `${
                                                isRTL ? "left-4" : "right-4"
                                              } top-2 z-10`
                                        }`}
                                        style={{
                                          transform:
                                            imgIndex > 0
                                              ? `rotate(${imgIndex * 4}deg)`
                                              : "",
                                        }}
                                      >
                                        {order.isImaginary && (
                                          <img
                                            src="/euror.png"
                                            alt="559384"
                                            className="absolute bottom-0"
                                            style={{
                                              right:
                                                window.innerWidth <= 768
                                                  ? "27px"
                                                  : "22px",
                                              zIndex: 0,
                                              maxWidth:
                                                window.innerWidth <= 768
                                                  ? "21px"
                                                  : "19px",
                                            }}
                                          />
                                        )}
                                        {order.platform === "tiktok" && (
                                          <img
                                            src="/tiktok.png" // حط لوجو تيك توك هنا
                                            alt={t("navbar.try.tiktok")}
                                            className="absolute top-0 right-0"
                                            style={{
                                              right:
                                                window.innerWidth <= 768
                                                  ? "0px"
                                                  : "0px",
                                              zIndex: 0,
                                              maxWidth:
                                                window.innerWidth <= 768
                                                  ? "21px"
                                                  : "18px",
                                            }}
                                          />
                                        )}
                                        {order.platform === "foorchat" && (
                                          <img
                                            src="/foorchat.gif" // حط لوجو تيك توك هنا
                                            alt="foorchat"
                                            className="absolute top-0 right-0"
                                            style={{
                                              right:
                                                window.innerWidth <= 768
                                                  ? "0px"
                                                  : "0px",
                                              zIndex: 0,
                                              maxWidth:
                                                window.innerWidth <= 768
                                                  ? "21px"
                                                  : "18px",
                                            }}
                                          />
                                        )}
                                        {order.platform === "facebook" && (
                                          <img
                                            src="/metaa.png" // حط لوجو ميتا/فيسبوك هنا
                                            alt="Meta"
                                            className="absolute top-0 left-0"
                                            style={{
                                              right:
                                                window.innerWidth <= 768
                                                  ? "0px"
                                                  : "0px",
                                              zIndex: 0,
                                              maxWidth:
                                                window.innerWidth <= 768
                                                  ? "21px"
                                                  : "18px",
                                            }}
                                          />
                                        )}
                                        <img
                                          src={product.image}
                                          alt={
                                            product.name ||
                                            t("ui.productNumber", { value0: (imgIndex + 1) })
                                          }
                                          className="w-full h-full object-cover"
                                          style={{
                                            border: order.isImaginary
                                              ? "2px solid #ffb400"
                                              : "2px solid white",
                                          }}
                                        />
                                      </div>
                                    ))}
                                  {order.products.filter((p) => p.image)
                                    .length > 3 && (
                                    <div
                                      className={`absolute -bottom-2 ${
                                        isRTL ? "-left-2" : "-right-2"
                                      } bg-[#9b59bf] text-white text-xs rounded-full w-6 h-6 flex items-center justify-center shadow-sm z-40`}
                                    >
                                      +
                                      {order.products.filter((p) => p.image)
                                        .length - 3}
                                    </div>
                                  )}
                                </>
                              ) : order.image ? (
                                <div className="absolute w-14 h-14 rounded-lg overflow-hidden bg-[#faf1ff] shadow-sm">
                                  <img
                                    src={order.image}
                                    alt={order.productName || t("settings.product")}
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                              ) : (
                                <div className="absolute w-14 h-14 rounded-lg overflow-hidden bg-[#faf1ff] shadow-sm flex items-center justify-center text-[#9e68ba]">
                                  <Tag size={24} />
                                </div>
                              )}
                            </div>
                          </td>

                          <td className="p-4 font-medium text-gray-800 dark:text-white">
                            {order.name}
                          </td>
                          <td className="p-4">
                            <div
                              className={`flex items-center gap-2 text-gray-700 ${
                                isRTL ? "justify-end" : "justify-start"
                              } dark:text-white`}
                            >
                              {isFreeCountry ? (
                                <span
                                  className="cursor-pointer"
                                  onClick={(e) =>
                                    handleCopyPhone(order.phone, e)
                                  }
                                >
                                  {order.phone}
                                </span>
                              ) : order?.isValid ? (
                                <img
                                  src="/lock.png"
                                  alt={t("orderDetails.top_section.image_alt")}
                                  className="mx-auto"
                                  onClick={() => handlePay(order)}
                                />
                              ) : (
                                <span
                                  className="cursor-pointer"
                                  onClick={(e) =>
                                    handleCopyPhone(order.phone, e)
                                  }
                                >
                                  {order.phone}
                                </span>
                              )}
                            </div>
                          </td>

                          {/* Order Date */}
                          <td className="p-4 text-gray-700 dark:text-white">
                            {order.timeStamp
                              ? formatDate(order.timeStamp)
                              : order.orderDate || t("dontexist")}
                          </td>

                          {(account.productMode ?? "classic") == "classic" && (
                            <td className="p-4 text-gray-700 dark:text-white">
                              {order.state}
                            </td>
                          )}

                          {(account.productMode ?? "classic") == "classic" && (
                            <td className="p-4">
                              <div
                                className={`flex items-center gap-2 ${
                                  isRTL ? "flex-row" : ""
                                }`}
                              >
                                <div
                                  className={`w-2.5 h-2.5 rounded-full ${
                                    ["completed", "5"].includes(
                                      order.status || order.deleveryStatus
                                    )
                                      ? "bg-green-500"
                                      : ["processing", "3", "9"].includes(
                                          order.status || order.deleveryStatus
                                        )
                                      ? "bg-blue-500"
                                      : ["pending", "1"].includes(
                                          order.status || order.deleveryStatus
                                        )
                                      ? "bg-yellow-500"
                                      : ["6", "11-5"].includes(
                                          order.deleveryStatus
                                        )
                                      ? "bg-red-500"
                                      : [
                                          "11-1",
                                          "11-2",
                                          "11-3",
                                          "11-4",
                                        ].includes(order.deleveryStatus)
                                      ? "bg-orange-500"
                                      : "bg-gray-500"
                                  }`}
                                ></div>

                                <div
                                  className={`px-3 py-1.5 rounded-md text-xs font-medium shadow-sm flex items-center justify-between min-w-24 ${
                                    ["completed", "5"].includes(
                                      order.status || order.deleveryStatus
                                    )
                                      ? "bg-green-50 text-green-700"
                                      : ["processing", "3", "9"].includes(
                                          order.status || order.deleveryStatus
                                        )
                                      ? "bg-blue-50 text-blue-700"
                                      : ["pending", "1"].includes(
                                          order.status || order.deleveryStatus
                                        )
                                      ? "bg-yellow-50 text-yellow-700"
                                      : ["6", "11-5"].includes(
                                          order.deleveryStatus
                                        )
                                      ? "bg-red-50 text-red-700"
                                      : [
                                          "11-1",
                                          "11-2",
                                          "11-3",
                                          "11-4",
                                        ].includes(order.deleveryStatus)
                                      ? "bg-orange-50 text-orange-700"
                                      : "bg-gray-50 text-gray-700"
                                  }`}
                                  onClick={() =>
                                    setActiveStatusDropdown(
                                      activeStatusDropdown === order.id
                                        ? null
                                        : order.id
                                    )
                                  }
                                >
                                  <span>{getStatusOrderText(order)}</span>
                                  <ChevronDown
                                    size={14}
                                    className="text-gray-600"
                                  />
                                </div>

                                {activeStatusDropdown === order.id && (
                                  <div
                                    className={`absolute mt-1 bg-white border border-gray-100 shadow-xl rounded-lg z-[200] min-w-48`}
                                  >
                                    <ul className="py-1 divide-y divide-gray-100">
                                      {order.deleveryStatus !== "5" &&
                                        [
                                          {
                                            status: "3",
                                            text: "dashboard.DataTableTemplatingDemoDashboard.confirmed",
                                          },
                                          ...(store.confirmChat
                                            ? [
                                                {
                                                  status: "9",
                                                  text: "dashboard.DataTableTemplatingDemoDashboard.confirmeduser",
                                                },
                                              ]
                                            : []),
                                          {
                                            status: "11-2",
                                            text: "dashboard.DataTableTemplatingDemoDashboard.noReponse",
                                          },
                                          {
                                            status: "11-3",
                                            text: "dashboard.DataTableTemplatingDemoDashboard.reporte",
                                          },
                                          {
                                            status: "6",
                                            text: "dashboard.DataTableTemplatingDemoDashboard.annuled",
                                          },
                                          {
                                            status: "11-5",
                                            text: "dashboard.DataTableTemplatingDemoDashboard.annuleduser",
                                          },
                                          {
                                            status: "11-1",
                                            text: "dashboard.DataTableTemplatingDemoDashboard.waituser",
                                          },
                                          {
                                            status: "11-4",
                                            text: "dashboard.DataTableTemplatingDemoDashboard.closedphone",
                                          },
                                        ].map((item) => (
                                          <li
                                            key={item.status}
                                            className={`px-4 py-2 cursor-pointer text-sm ${
                                              order.deleveryStatus ===
                                              item.status
                                                ? `bg-${
                                                    item.status === "6" ||
                                                    item.status === "11-5"
                                                      ? "red"
                                                      : item.status === "3" ||
                                                        item.status === "9"
                                                      ? "blue"
                                                      : "orange"
                                                  }-50 text-${
                                                    item.status === "6" ||
                                                    item.status === "11-5"
                                                      ? "red"
                                                      : item.status === "3" ||
                                                        item.status === "9"
                                                      ? "blue"
                                                      : "orange"
                                                  }-700`
                                                : "hover:bg-gray-50"
                                            } ${
                                              isRTL ? "text-right" : "text-left"
                                            }`}
                                            onClick={() => {
                                              changeStatus(order, item.status);
                                              setActiveStatusDropdown(null);
                                            }}
                                          >
                                            {t(item.text)}
                                          </li>
                                        ))}
                                      <li
                                        className={`px-4 py-2 cursor-pointer text-sm ${
                                          order.deleveryStatus === "5"
                                            ? "bg-green-50 text-green-700"
                                            : "hover:bg-green-50"
                                        } ${
                                          isRTL ? "text-right" : "text-left"
                                        }`}
                                        onClick={() => {
                                          changeStatus(order, "5");
                                          setActiveStatusDropdown(null);
                                        }}
                                      >
                                        {t(
                                          "dashboard.DataTableTemplatingDemoDashboard.completed"
                                        )}
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </td>
                          )}

                          {/* Total */}
                          <td className="p-4">
                            <span className="bg-[#faf1ff] text-[#9e68ba] dark:bg-[#3c1a4d] dark:text-[#ddb6f2] px-3 py-1 rounded-lg">
                              {order.total} {store?.currencySymbol}
                            </span>
                          </td>

                          {/* Actions */}
                          <td className="p-4">
                            <div className="relative">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOpenDropdownId(
                                    openDropdownId === order.id
                                      ? null
                                      : order.id
                                  );
                                }}
                                className="p-2 rounded-full hover:bg-purple-100 dark:hover:bg-[#3c1a4d] transition-colors"
                              >
                                <MoreVertical
                                  size={18}
                                  className="text-[#9e68ba]"
                                />
                              </button>
                              {openDropdownId === order.id && (
                                <div
                                  className={`absolute ${
                                    isRTL ? "right-0" : "left-0"
                                  } mt-1 bg-white dark:text-white dark:!bg-[#181919] border border-[#fbf4ff] shadow-lg rounded-lg z-[200] min-w-32`}
                                >
                                  <ul className="py-1">
                                    <li
                                      onClick={() => {
                                        navigateToOrder(order.id);
                                        setOpenDropdownId(null);
                                      }}
                                      className={`px-4 py-2 hover:bg-[#fcf6ff] cursor-pointer flex items-center gap-2 ${
                                        isRTL ? "flex-row-reverse" : ""
                                      }`}
                                    >
                                      <Eye
                                        size={14}
                                        className="text-blue-600"
                                      />
                                      <span>{t("ship.view")}</span>
                                    </li>
                                  </ul>
                                </div>
                              )}
                            </div>
                          </td>

                          {/* Expand/Collapse */}
                          <td className="p-4">
                            <button
                              onClick={() => toggleRow(order.id)}
                              className="p-2 rounded-full hover:bg-[#faf1ff] dark:hover:bg-[#3c1a4d] transition-colors"
                            >
                              {expandedRows[order.id] ? (
                                <ChevronUp
                                  size={18}
                                  className="text-[#9e68ba]"
                                />
                              ) : (
                                <ChevronDown
                                  size={18}
                                  className="text-[#9e68ba]"
                                />
                              )}
                            </button>
                          </td>
                        </tr>

                        {/* Expanded Row */}
                        {expandedRows[order.id] && (
                          <tr className="dark:!bg-[#181919]">
                            <td
                              colSpan={
                                (account.productMode ?? "classic") == "classic"
                                  ? 9
                                  : 7
                              }
                              className="p-0"
                            >
                              <div className="h-fit overflow-y-auto">
                                <div
                                  className="p-6 rounded-xl bg-white border border-[#fbf4ff] dark:!border-[#3c3a3d] dark:!bg-[#181919] shadow-md m-4"
                                  dir={isRTL ? "rtl" : "ltr"}
                                >
                                  <h4
                                    className={`text-lg font-medium mb-4 text-[#9e68ba] border-b border-[#fbf4ff] dark:!border-[#3c3a3d] pb-2 sticky top-0 bg-white dark:!bg-[#181919] z-10 ${
                                      isRTL ? "text-right" : "text-left"
                                    }`}
                                  >
                                    {t(
                                      "dashboard.DataTableTemplatingDemoDashboard.detail_orders"
                                    )}
                                  </h4>

                                  {(account.productMode ?? "classic") ==
                                  "classic" ? (
                                    <>
                                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                        {[
                                          {
                                            title:
                                              "dashboard.DataTableTemplatingDemoDashboard.adress",
                                            content:
                                              order.state ||
                                              order.commune ||
                                              order.address
                                                ? `${order.state} - ${order.commune} - ${order.address}`
                                                : t("dontexist"),
                                          },
                                          {
                                            title:
                                              "dashboard.DataTableTemplatingDemoDashboard.paimentMethos",
                                            content:
                                              order.paymentType ||
                                              t("dontexist"),
                                          },
                                          {
                                            title:
                                              "dashboard.DataTableTemplatingDemoDashboard.note",
                                            content:
                                              order.note || t("dontexist"),
                                          },
                                        ].map((item, index) => (
                                          <div
                                            key={index}
                                            className="bg-[#fcf6ff] dark:!bg-[#181919] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d]"
                                          >
                                            <h5
                                              className={`text-sm font-medium text-[#9e68ba] dark:text-white mb-2 ${
                                                isRTL
                                                  ? "text-right"
                                                  : "text-left"
                                              }`}
                                            >
                                              {t(item.title)}
                                            </h5>
                                            <p
                                              className={`text-gray-700 dark:text-gray-300 ${
                                                isRTL
                                                  ? "text-right"
                                                  : "text-left"
                                              }`}
                                            >
                                              {item.content}
                                            </p>
                                          </div>
                                        ))}
                                      </div>

                                      {order.products?.some((p) => p.image) && (
                                        <div className="mt-6">
                                          <h5
                                            className={`text-sm font-medium text-[#9e68ba] mb-3 border-b border-[#fbf4ff] dark:!border-[#3c3a3d] pb-2 ${
                                              isRTL ? "text-right" : "text-left"
                                            }`}
                                          >
                                            {t(
                                              "dashboard.DataTableTemplatingDemoDashboard.productsPhotos"
                                            )}
                                          </h5>
                                          <div
                                            className={`flex flex-wrap gap-3 ${
                                              isRTL ? "flex-row-reverse" : ""
                                            }`}
                                          >
                                            {order.products
                                              .filter((p) => p.image)
                                              .map((product, imgIndex) => (
                                                <div
                                                  key={imgIndex}
                                                  className="w-20 h-20 rounded-lg overflow-hidden border border-[#fbf4ff] dark:!border-[#3c3a3d] shadow-sm"
                                                >
                                                  <img
                                                    src={product.image}
                                                    alt={
                                                      product.name ||
                                                      t("ui.productNumber", { value0: (imgIndex + 1) })
                                                    }
                                                    className="w-full h-full object-cover"
                                                  />
                                                </div>
                                              ))}
                                          </div>
                                        </div>
                                      )}

                                      {order.products?.length > 0 && (
                                        <div className="mt-6">
                                          <h5
                                            className={`text-sm font-medium text-[#9e68ba] mb-3 border-b border-[#fbf4ff] dark:!border-[#3c3a3d] pb-2 ${
                                              isRTL ? "text-right" : "text-left"
                                            }`}
                                          >
                                            {t(
                                              "dashboard.DataTableTemplatingDemoDashboard.products"
                                            )}
                                          </h5>

                                          <div
                                            className={`grid grid-cols-5 bg-[#fcf6ff] dark:!bg-[#181919] rounded-t-lg p-3 border border-[#fbf4ff] dark:!border-[#3c3a3d] border-b-0 ${
                                              isRTL ? "text-right" : "text-left"
                                            }`}
                                          >
                                            {[
                                              "dashboard.DataTableTemplatingDemoDashboard.product",
                                              "dashboard.DataTableTemplatingDemoDashboard.price",
                                              "dashboard.DataTableTemplatingDemoDashboard.quantity",
                                              "dashboard.DataTableTemplatingDemoDashboard.color",
                                              "dashboard.DataTableTemplatingDemoDashboard.choice",
                                            ].map((header, i) => (
                                              <div
                                                key={i}
                                                className="text-sm font-medium text-[#9e68ba]"
                                              >
                                                {t(header)}
                                              </div>
                                            ))}
                                          </div>

                                          <div className="border border-[#fbf4ff] dark:!border-[#3c3a3d] rounded-b-lg divide-y divide-purple-100 bg-white dark:!bg-[#181919]">
                                            {order.products.map(
                                              (product, i) => (
                                                <div
                                                  key={i}
                                                  className={`grid grid-cols-5 p-3 items-center hover:bg-[#fcf6ff] transition-colors ${
                                                    isRTL
                                                      ? "text-right"
                                                      : "text-left"
                                                  }`}
                                                >
                                                  <div className="font-medium text-gray-700 flex items-center gap-2 dark:text-white">
                                                    {product.image && (
                                                      <div className="w-8 h-8 rounded overflow-hidden flex-shrink-0">
                                                        <img
                                                          src={product.image}
                                                          alt={product.name}
                                                          className="w-full h-full object-cover"
                                                        />
                                                      </div>
                                                    )}
                                                    <span>{product.name}</span>
                                                  </div>
                                                  <div className="text-gray-700 dark:text-white">
                                                    {product.price}{" "}
                                                    {store?.currencySymbol}
                                                  </div>
                                                  <div className="text-gray-700 dark:text-white">
                                                    {product.quantity}
                                                  </div>
                                                  <div className="text-gray-700 dark:text-white flex items-center gap-2">
                                                    {product.options?.color ||
                                                    product.color ? (
                                                      <div
                                                        className={`flex items-center gap-1 ${
                                                          isRTL
                                                            ? "flex-row-reverse"
                                                            : ""
                                                        }`}
                                                      >
                                                        <div
                                                          className="w-4 h-4 rounded-full border border-gray-200 flex-shrink-0"
                                                          style={{
                                                            backgroundColor:
                                                              product.options
                                                                ?.color ||
                                                              product.color,
                                                          }}
                                                        />
                                                        <span>
                                                          {product.options
                                                            ?.color ||
                                                            product.color}
                                                        </span>
                                                      </div>
                                                    ) : (
                                                      "—"
                                                    )}
                                                  </div>
                                                  <div className="text-gray-700 dark:text-white">
                                                    {product.options?.length > 0
                                                      ? product.options
                                                          .map(
                                                            (opt) => opt.size
                                                          )
                                                          .filter(Boolean)
                                                          .join(", ") || "—"
                                                      : product.color ||
                                                        product.size ||
                                                        "—"}
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                      <div className="bg-[#fcf6ff] dark:!bg-[#181919] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                                        <h5 className="text-sm font-medium text-[#9e68ba] dark:text-white mb-2">
                                          {t("datatable_templating_tr.customer_name")}
                                        </h5>
                                        <p className="m-0 text-green-600 font-bold">
                                          {order.name}
                                        </p>
                                      </div>
                                      <div className="bg-[#fcf6ff] dark:!bg-[#181919] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                                        <h5 className="text-sm font-medium text-[#9e68ba] dark:text-white mb-2">
                                          {t("phone")}
                                        </h5>
                                        <a
                                          href={`tel:${order.phone}`}
                                          style={{ textDecoration: "none" }}
                                        >
                                          <p className="m-0 text-green-600 font-bold">
                                            {order.phone}
                                          </p>
                                        </a>
                                      </div>
                                      <div className="bg-[#fcf6ff] dark:!bg-[#181919] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                                        <h5 className="text-sm font-medium text-[#9e68ba] dark:text-white mb-2">
                                          {t("login.auth.email")}
                                        </h5>
                                        <p className="m-0 text-success">
                                          <b>
                                            {order.email
                                              ? order.email
                                              : t("ui.notAvailable")}
                                          </b>
                                        </p>
                                      </div>
                                      <div className="bg-[#fcf6ff] dark:!bg-[#181919] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                                        <h5 className="text-sm font-medium text-[#9e68ba] dark:text-white mb-2">
                                          {t("ui.note")}
                                        </h5>
                                        <p className="m-0 text-green-600 font-bold">
                                          {order.note || t("ship.no_note")}
                                        </p>
                                      </div>
                                      <div className="bg-[#fcf6ff] dark:!bg-[#181919] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                                        <h5 className="text-sm font-medium text-[#9e68ba] dark:text-white mb-2">
                                          {t("orders.datatable_templating_demo.ip_address")}
                                        </h5>
                                        <p className="m-0 text-green-600 font-bold">
                                          <b>
                                            {order.ipAddress
                                              ? order.ipAddress
                                              : "-"}
                                          </b>
                                        </p>
                                      </div>
                                      <div className="bg-[#fcf6ff] dark:!bg-[#181919] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                                        <h5 className="text-sm font-medium text-[#9e68ba] dark:text-white mb-2">
                                          {t("ship.product_value")}
                                        </h5>
                                        <p className="m-0 text-green-600 font-bold">
                                          {order.total -
                                            (order.deliveryPrice || 0)}{" "}
                                          {order.currencySymbol}
                                        </p>
                                      </div>
                                      <div className="bg-[#fcf6ff] dark:!bg-[#181919] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                                        <h5 className="text-sm font-medium text-[#9e68ba] dark:text-white mb-2">
                                          {t("quantity")}
                                        </h5>
                                        <p className="m-0 text-green-600 font-bold">
                                          {order.qty ?? 1}
                                        </p>
                                      </div>
                                      <div className="bg-[#fcf6ff] dark:!bg-[#181919] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                                        <h5 className="text-sm font-medium text-[#9e68ba] dark:text-white mb-2">
                                          {t("Products.Table.expand.info.title")}
                                        </h5>
                                        <p className="m-0 text-success">
                                          <b>
                                            {order.products?.[0]?.key ??
                                              t("ui.toBeDetermined")}
                                          </b>
                                        </p>
                                      </div>
                                      <div className="bg-[#fcf6ff] dark:!bg-[#181919] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                                        <h5 className="text-sm font-medium text-[#9e68ba] dark:text-white mb-2">
                                          {t("ship.order_status")}
                                        </h5>
                                        <p className="m-0 text-green-600 font-bold">
                                          <b>
                                            {STATUS_LABELS[order.status] ??
                                              t("unspecified")}
                                          </b>
                                        </p>
                                      </div>
                                      <div className="bg-[#fcf6ff] dark:!bg-[#181919] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                                        <h5 className="text-sm font-medium text-[#9e68ba] dark:text-white mb-2">
                                          {t("foorchat.stats.paymentMethod")}
                                        </h5>
                                        <p className="m-0 text-success">
                                          <b>
                                            {order.paymentMethod ??
                                              t("ui.toBeDetermined")}
                                          </b>
                                        </p>
                                      </div>
                                      <div className="bg-[#fcf6ff] dark:!bg-[#181919] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                                        <h5 className="text-sm font-medium text-[#9e68ba] dark:text-white mb-2">
                                          {t("ship.total_amount")}
                                        </h5>
                                        <p className="m-0 text-green-600 font-bold">
                                          {order.total} {order.currencySymbol}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan={
                        (account.productMode ?? "classic") == "classic" ? 9 : 7
                      }
                      className="p-8 text-center text-gray-500"
                    >
                      {t("dashboard.DataTableTemplatingDemoDashboard.nodata")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="d-flex justify-content-center py-3 bg-white dark:!bg-[#181919] mt-4 rounded-xl border border-[#fbf4ff] dark:!border-[#3c3a3d]">
          <Stack spacing={2} dir="ltr">
            <Pagination
              count={count}
              size="large"
              page={page}
              variant="outlined"
              shape="rounded"
              onChange={handleChange}
              color="secondary"
              sx={{
                backgroundColor: isDark ? "#181919" : "#ffffff",
                borderRadius: 2,
                p: 2,
                "& .MuiPaginationItem-root": {
                  color: isDark ? "#e1cfff" : "#000000",
                  borderColor: isDark ? "#a065c0" : "#ccc",
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: isDark ? "#9b59bf" : "#9b59bf",
                  color: "#fff",
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: isDark ? "#7c3aad" : "#f0f0f0",
                },
              }}
            />
          </Stack>
        </div>
      </div>
    </div>
  );
};

export default DataTableTemplatingDemoDashboard;
